'use strict';

var debug = require('debug');

var log = debug('libp2p:websockets:dialer');

function maToUrl(ma) {
  var maStrSplit = ma.toString().split('/');
  var proto;

  try {
    proto = ma.protoNames().filter(function (proto) {
      return proto === 'ws' || proto === 'wss';
    })[0];
  } catch (e) {
    log(e);
    throw new Error('Not a valid websocket address', e);
  }

  var port;

  try {
    port = ma.stringTuples().filter(function (tuple) {
      if (tuple[0] === ma.protos().filter(function (proto) {
        return proto.name === 'tcp';
      })[0].code) {
        return true;
      }
    })[0][1];
  } catch (e) {
    log('No port, skipping');
  }

  var url = "".concat(proto, "://").concat(maStrSplit[2]).concat(port && (port !== 80 || port !== 443) ? ":".concat(port) : '');
  return url;
}

module.exports = maToUrl;